import * as Fetch from '../data/Fetch';
import * as utility from '../data/Utility';

const setAllStudiesType = 'SET_ALL_STUDIES';
const setAllCompSchedulesType = 'SET_ALL_COMP_SCHEDULES';
const setBlankingPeriodDaysType = 'SET_BLANKING_PERIOD_DAYS';
const setLength12LeadType = 'SET_LENGTH_12LEAD';
const setLengthEventType = 'SET_LENGTH_EVENT';
const setLengthHolterType = 'SET_LENGTH_HOLTER';
const setStudiesFetchingType = 'SET_STUDIES_FETCHING';
const setStudyType = 'SET_STUDY';
const setStudySchedulingType = 'SET_STUDY_SCHEDULING';

/* Careful: these must keep the same uppercase/lowercase as done here, so that they match the exact names in the study object */
export const SchedCompType = {
    allCompSchedules: "allCompSchedules",
    blankingPeriodDays: "blankingPeriodDays",
    length12Lead: "length12Lead",
    lengthEvent: "lengthEvent",
    lengthHolter: "lengthHolter",
}

const initialState = {
    all: null,
    fetching: false,
    study: null
};

export const emptyStudy = {
    code: "",
    crfQnaEvent: [],
    crfQnaHolter: [],
    crfQna12Lead: [],
    endDateTime: null,
    name: "",
    isServiceEvent: false,
    isServiceHolter: false,
    isService12Lead: false,
	priceEvent: 0,
	priceHolter: 0,
	price12lead: 0,
	lengthEvent: 0,
	lengthHolter: 0,
	length12lead: 0,
	blankingPeriodDays: 0,
	allCompSchedules: { "Event": "", "Holter": "", "12-Lead": "" },
	sponsorId: "",
    startDateTime: null
};

export const actionCreators = {
    create: (sponsorId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const studiesState = getState().studies;
        if (badState(accountsState, studiesState, true, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Studies/AddNew");
        const study = studiesState.study;
        const endDateTime = utility.getDateTimeJson(study.endDateTime);
        const startDateTime = utility.getDateTimeJson(study.startDateTime);

        const body = JSON.stringify({
            code: study.code,
            crfQnaEvent: JSON.stringify(study.crfQnaEvent),
            crfQnaHolter: JSON.stringify(study.crfQnaHolter),
            crfQna12Lead: JSON.stringify(study.crfQna12Lead),
            allCompSchedules: JSON.stringify(study.allCompSchedules),
            endDateTime: endDateTime,
            isServiceEvent: study.isServiceEvent,
            isServiceHolter: study.isServiceHolter,
            isService12Lead: study.isService12Lead,
			priceEvent: study.priceEvent,
			priceHolter: study.priceHolter,
			price12lead: study.price12lead,
			lengthEvent: study.lengthEvent,
			lengthHolter: study.lengthHolter,
			length12lead: study.length12lead,
			blankingPeriodDays: study.blankingPeriodDays,
            name: study.name,
            sponsorId: sponsorId,
            startDateTime: startDateTime
        });
        await Fetch.postRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    get: (studyId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const studiesState = getState().studies;
        if (badState(accountsState, studiesState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Studies/GetById?id=${studyId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setStudyType);
    },

    getAll: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const studiesState = getState().studies;
        if (badState(accountsState, studiesState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Studies/GetAll");
        await getAllInternal(url, accountsState.authenticatedToken, dispatch);
    },

    getAllByAuthenticatedUser: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const studiesState = getState().studies;
        if (badState(accountsState, studiesState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Studies/GetAllByAuthenticatedUser");
        getAllInternal(url, accountsState.authenticatedToken, dispatch);
    },

    getAllBySponsor: (sponsorId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const studiesState = getState().studies;
        if (badState(accountsState, studiesState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Studies/GetAllBySponsor?sponsorId=${sponsorId}`);
        getAllInternal(url, accountsState.authenticatedToken, dispatch);
    },

    getAllByUser: (userId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const studiesState = getState().studies;
        if (badState(accountsState, studiesState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Studies/GetAllByUser?userId=${userId}`);
        getAllInternal(url, accountsState.authenticatedToken, dispatch);
    },

    getAllUnlinked: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const studiesState = getState().studies;
        if (badState(accountsState, studiesState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Studies/GetAllUnlinked");
        getAllInternal(url, accountsState.authenticatedToken, dispatch);
    },

    getAllCompSchedules: (studyId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const studiesState = getState().studies;
        if (badState(accountsState, studiesState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Studies/GetCompSchedule?studyId=${studyId}`);
		const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
		// data = { "Event": [], "Holter": [], "12-Lead": [] };
		setResponse(data, dispatch, setAllCompSchedulesType);
    },


    set: (data) => async (dispatch) => {
        dispatch({ type: setStudyType, data });
    },

    setScheduling: (whichOne,data) => async (dispatch) => {
		switch ( whichOne ) {
			case SchedCompType.allCompSchedules:
				dispatch({ type: setAllCompSchedulesType, data });
				break;
			case SchedCompType.blankingPeriodDays:
				dispatch({ type: setBlankingPeriodDaysType, data });
				break;
			case SchedCompType.length12Lead:
				dispatch({ type: setLength12LeadType, data });
				break;
			case SchedCompType.lengthEvent:
				dispatch({ type: setLengthEventType, data });
				break;
			case SchedCompType.lengthHolter:
				dispatch({ type: setLengthHolterType, data });
				break;
			default:
				break;
		}
    },

    setAll: (data) => async (dispatch) => {
        dispatch({ type: setAllStudiesType, data });
    },

    update: (sponsorId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const studiesState = getState().studies;
        if (badState(accountsState, studiesState, true, dispatch)) {
            return;
        }

        const study = studiesState.study;

		let strCrfQnaEvent = null;
		let strCrfQnaHolter = null;
		let strCrfQna12Lead = null;
		let allCompSchedules = null;

		if ( typeof study.crfQnaEvent === 'string' || study.crfQnaEvent instanceof String ) {
			strCrfQnaEvent = study.crfQnaEvent;
		} else {
			strCrfQnaEvent = JSON.stringify(study.crfQnaEvent);
		}

		if ( typeof study.crfQnaHolter === 'string' || study.crfQnaHolter instanceof String ) {
			strCrfQnaHolter = study.crfQnaHolter;
		} else {
			strCrfQnaHolter = JSON.stringify(study.crfQnaHolter);
		}

		if ( typeof study.crfQna12Lead === 'string' || study.crfQna12Lead instanceof String ) {
			strCrfQna12Lead = study.crfQna12Lead;
		} else {
			strCrfQna12Lead = JSON.stringify(study.crfQna12Lead);
		}

		if ( typeof study.allCompSchedules === 'string' || study.allCompSchedules instanceof String ) {
			allCompSchedules = study.allCompSchedules;
		} else {
			allCompSchedules = JSON.stringify(study.allCompSchedules);
		}

        const url = await Fetch.getUrl(`Studies/Update?id=${study.id}`);
        const endDateTime = utility.getDateTimeJson(study.endDateTime);
        const startDateTime = utility.getDateTimeJson(study.startDateTime);
        const body = JSON.stringify({
            code: study.code,
            crfQnaEvent: strCrfQnaEvent,
            crfQnaHolter: strCrfQnaHolter,
            crfQna12Lead: strCrfQna12Lead,
            allCompSchedules: allCompSchedules,
            endDateTime: endDateTime,
            isServiceEvent: study.isServiceEvent,
            isServiceHolter: study.isServiceHolter,
            isService12Lead: study.isService12Lead,
			priceEvent: study.priceEvent,
			priceHolter: study.priceHolter,
			price12lead: study.price12lead,
			lengthEvent: study.lengthEvent,
			lengthHolter: study.lengthHolter,
			length12lead: study.length12lead,
			blankingPeriodDays: study.blankingPeriodDays,
            name: study.name,
            sponsorId: sponsorId,
            startDateTime: startDateTime
        });
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    }
};

function badState(accountsState, studiesState, checkStudy, dispatch) {
    if (accountsState == null ||
        studiesState == null ||
        studiesState.fetching) {
        return true;
    }
    if (checkStudy &&
        studiesState.study == null) {
        return true;
    }

    setFetching(true, dispatch);
    return false;
}

async function getAllInternal(url, token, dispatch) {
    const data = await Fetch.getRequest(url, token);
    setResponse(data, dispatch, setAllStudiesType);
}

function setFetching(data, dispatch) {
    dispatch({ type: setStudiesFetchingType, data });
}

function setResponse(data, dispatch, type) {
    Fetch.setResponse(data, dispatch, type, setStudiesFetchingType);
}

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === setAllStudiesType) {
        return {
            ...state,
            all: action.data
        };
    }

    if (action.type === setAllCompSchedulesType) {
		const theStudy = {...state.study, allCompSchedules: action.data };
        return {
            ...state,
            study: theStudy
        };
    }

    if (action.type === setBlankingPeriodDaysType) {
		const theStudy = {...state.study, blankingPeriodDays: (action.data) ? action.data : 0 };
        return {
            ...state,
            study: theStudy
        };
    }

    if (action.type === setLength12LeadType) {
		const theStudy = {...state.study, length12lead: (action.data) ? action.data : 0 };
        return {
            ...state,
            study: theStudy
        };
    }

    if (action.type === setLengthEventType) {
		const theStudy = {...state.study, lengthEvent: (action.data) ? action.data : 0 };
        return {
            ...state,
            study: theStudy
        };
    }

    if (action.type === setLengthHolterType) {
		const theStudy = {...state.study, lengthHolter: (action.data) ? action.data : 0 };
        return {
            ...state,
            study: theStudy
        };
    }

    if (action.type === setStudiesFetchingType) {
        return {
            ...state,
            fetching: action.data
        };
    }

    if (action.type === setStudyType) {
        return {
            ...state,
            study: action.data
        };
    }

    if (action.type === setStudySchedulingType) {
        return {
            ...state,
            studyScheduling: action.data
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/Studies.js